import React from "react";
import useDocumentTitle from "../useDocumentTitle";
import Header from "../headerComponent/Header.js";
import ssl_sertifikasi from "./ssl_sertifikasi.png"
import ssl from "../footer/ssl.png";
import "./Gizlilik.css";

function Gizlilik() {
  useDocumentTitle('Gizlilik Politikası - Herbalife')
  return (
    <div classNameName="row">
      <Header page_title="Gizlilik Politikası" />
      <div className="row" id="row-907753893" style={{padding:"1.5rem"}}>
                <div id="col-956660236" className="col medium-8 small-12 large-8">
                  <div className="col-inner">
                    <h5>Hangi kişisel bilgileri ne amaçla topluyoruz</h5>
                    <h5>Yorumlar</h5>
                    <p style={{textAlign:"justify"}}>
                      Ziyaretçiler sitede yorum bıraktığında yorum formunda
                      gösterilen verileri ve ayrıca istenmeyen yorum tespitine
                      yardımcı olmak için ziyaretçinin IP adresi ve tarayıcı
                      bilgisi metnini de toplarız.
                    </p>
                    <p style={{textAlign:"justify"}}>
                      E-posta adresinizden oluşturulmuş anonimleştirilmiş bir
                      metin (hash olarak da adlandırılır) Gravatar hizmetine,
                      servisi kullanıp kullanmadığınızı görmek için,
                      sağlanabilir. Gravatar servisinin gizlilik politikası şu
                      adrestedir: https://automattic.com/privacy/. Yorumunuzun
                      onaylanmasından sonra profil resminiz yorumunuzla birlikte
                      herkese görünür.
                    </p>
                  </div>
                </div>

                <div id="col-1763197399" className="col medium-4 small-12 large-4" style={{padding:"1.5rem"}}>
                  <div className="col-inner">
                    <div
                      className="img has-hover x md-x lg-x y md-y lg-y"
                      id="image_1068915918"
                    >
                      <div className="img-inner dark">
                        <img className="gizlilik_ssl_sertifikasi"
                          src={ssl_sertifikasi}
                          
                          
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row" id="row-335948866" style={{padding:"1.5rem"}}>
                <div id="col-1906012489" className="col medium-3 small-12 large-3">
                  <div className="col-inner">
                    <div
                      className="img has-hover x md-x lg-x y md-y lg-y"
                      id="image_756579150"
                    >
                      <div className="img-inner dark">
                        <img className="gizlilik_ssl"
                          src={ssl}
                          
                          
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div id="col-2091993361" className="col medium-9 small-12 large-9" style={{padding:"1.5rem"}}>
                  <div className="col-inner">
                    <h5>Ortam</h5>
                    <p style={{textAlign:"justify"}}>
                      Görselleri web sitesine yüklerseniz, gömülmüş konum
                      verileri (EXIF GPS) içeren görseller yüklemekten
                      kaçınmalısınız. Web sitesi ziyaretçileri, web sitesindeki
                      görsellerden herhangi bir konum bilgisini indirip
                      çıkarabilir.
                    </p>
                    <p>&nbsp;</p>
                  </div>
                </div>
              </div>
              <div className="row" id="row-1330621769" style={{padding:"1.5rem"}}>
                <div id="col-1291128010" className="col small-12 large-12" >
                  <div className="col-inner">
                    <h5>Çerezler</h5>
                    <p style={{textAlign:"justify"}}>
                      Sitemize bir yorum bırakırsanız, isminizi, e-posta
                      adresinizi ve web sitenizi çerezlerde kaydetmeyi
                      seçebilirsiniz. Bunlar size kolaylık sağlamak içindir,
                      böylece başka bir yorum bıraktığınızda bilgilerinizi
                      tekrar doldurmanız gerekmez. Bu çerezler bir yıl süresince
                      kalır.
                    </p>
                    <p style={{textAlign:"justify"}}>
                      Eğer giriş sayfasımızı ziyaret ederseniz, tarayıcınızın
                      çerezleri kabul edip etmediğini belirlemek için geçici bir
                      çerez ayarlayacağız. Bu çerez hiçbir kişisel veri içermez
                      ve tarayıcınızı kapattığınızda atılır.
                    </p>
                    <p style={{textAlign:"justify"}}>
                      Giriş yaptığınızda, giriş bilgilerinizi ve ekran
                      görüntüleme seçiminizi kaydetmek için birkaç çerez
                      kaydedeceğiz. Giriş çerezleri iki gün ve ekran seçenekleri
                      çerezleri bir yıl boyunca kalır. “Beni hatırla” seçeneğini
                      seçereniz, girişiniz iki hafta boyunca devam eder.
                      Hesabınızdan çıkış yaparsanız, giriş çerezleri
                      kaldırılacaktır.
                    </p>
                    <p style={{textAlign:"justify"}}>
                      Bir makaleyi düzenler veya yayınlarsanız tarayıcınıza ek
                      bir çerez kaydedilir. Bu çerez hiçbir kişisel veri içermez
                      ve sadece düzenlediğiniz makalenin yazı kimliğini
                      gösterir. 1 gün sonra zaman aşımına uğrar.
                    </p>
                    <h5>Diğer sitelerden gömülen içerik</h5>
                    <p style={{textAlign:"justify"}}>
                      Bu sitedeki makaleler gömülü içerik (ör. videolar,
                      görseller, makaleler, vb.) Içerebilir. Diğer web
                      sitelerinden gömülen içerik, ziyaretçinin diğer web
                      sitesini ziyaret etmiş gibi, tam olarak aynı şekilde
                      davranır.
                    </p>
                    <p style={{textAlign:"justify"}}>
                      Bu web siteleri sizin hakkınızda veri toplayabilir, çerez
                      kullanabilir, üçüncü taraf tarafından gömülmüş şeklide
                      takip yapabilir ve bir hesabınız varsa ve bu web sitesinde
                      oturum açtıysanız, gömülen içerikle etkleşiminizi takip
                      etme dahil olmak üzere, bu gömülen içerikle etkileşiminizi
                      izleyebilir.
                    </p>
                    <h5>Verilerinizi ne kadar süre tutarız</h5>
                    <p style={{textAlign:"justify"}}>
                      Bir yorum bırakırsanız, yorum ve meta verileri süresiz
                      olarak saklanır. Böylece, takip eden yorumlarınızı denetim
                      kuyruğunda tutmak yerine otomatik olarak tanıyabilir ve
                      onaylayabiliriz.
                    </p>
                    <p style={{textAlign:"justify"}}>
                      Web sitemize kayıt yaptıran kullanıcılar için (varsa)
                      kullanıcı profilinde sağladıkları kişisel bilgileri de
                      saklarız. Tüm kullanıcılar kişisel bilgilerini istedikleri
                      zaman görebilir, düzenleyebilir veya silebilir (kullanıcı
                      adı değiştirme hariç). Web sitesi yöneticileri de bu
                      bilgileri görebilir ve düzenleyebilir.
                    </p>
                    <h5>Verileriniz üzerindeki haklarınız neler</h5>
                    <p style={{textAlign:"justify"}}>
                      Bu sitede bir hesabınız veya yorumlarınız varsa, bize
                      sağladığınız veriler dahil olmak üzere, hakkınızda
                      tuttuğumuz kişisel verilerin dışa aktarılmış bir dosyasını
                      almayı isteyebilirsiniz. Ayrıca, hakkınızda tuttuğumuz tüm
                      kişisel verileri de silmeyi isteyebilirsiniz. Bu, idari,
                      yasal veya güvenlik amaçlarına uymak zorunda olduğumuz
                      hiçbir veriyi içermez.
                    </p>
                    <h5>Verinizi nereye gönderiyoruz</h5>
                    <p style={{textAlign:"justify"}}>
                      Ziyaretçi yorumları otomatik istenmeyen yorum algılama
                      servisi aracılığıyla kontrol edilebilir.
                    </p>
                    <h5>Gizlilik ihlali bildirimi</h5>
                    <p style={{textAlign:"justify"}}>
                      Gizliliğinizin ihlal edildiğini ve verilerinizin güvende
                      olmadığını düşünüyorsanız bizimle iletişim sayfamızdan
                      iletişim kurarak çerez verilerinizin silinmesini
                      isteyebilirsiniz.
                    </p>
                  </div>
                </div>
              </div>

    </div>
  );
}

export default Gizlilik;
